import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { trackMixpanelPageView } from 'helpers/post';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { registrationFieldUpdate, postEventProfileFieldValidate } from 'redux/ducks/Registration';
import { changeProfileField } from 'redux/ducks/Post/Profile';
import { update } from 'redux/ducks/User';
import { requireOrganizationData } from 'helpers/dashboard';
import './Organization.scss';

class Organization extends Component {
  componentDidMount() {
    trackMixpanelPageView('create-event/organization', this.props.user);
  }

  onFieldChange = field => {
    return ev => {
      this.props.updateField(field, ev.currentTarget.value);
      this.props.validateProfileField(field);
    };
  };

  onContinue = () => {
    const { user, profileValidation, currentUser } = this.props;

    // Validate required fields
    this.props.validateProfileField('companyName');
    this.props.validateProfileField('organizationWebsite');

    // Check if all required fields are valid
    const hasErrors =
      profileValidation.errors.companyName ||
      profileValidation.errors.organizationWebsite;

    if (!hasErrors && user.companyName && user.organizationWebsite) {
      // Create updated user object with organization data
      const updatedUser = {
        ...currentUser,
        companyName: user.companyName,
        organizationWebsite: user.organizationWebsite,
      };

      this.props.changeProfileField('companyName', user.companyName);
      this.props.changeProfileField('organizationWebsite', user.organizationWebsite);

      // Save to backend using User update epic
      this.props.updateUser(updatedUser);
    }
  };

  render() {
    const { user, profileValidation, flash, userErrors } = this.props;

    return (
      <div className="v2OrganizationScene gotham-regular-font">
        <header>
          <div className="info-text">Tell us about your organization</div>
        </header>
        {flash.message && flash.type === 'error' && (
          <div className="alert alert-danger alert-margin" role="alert">
            {flash.message}
          </div>
        )}
        {userErrors && Object.keys(userErrors).length > 0 && (
          <div className="alert alert-danger alert-margin" role="alert">
            {Object.values(userErrors).join(', ')}
          </div>
        )}
        <form
          id="organizationForm"
          className="v2organizationForm nimbus-regular-font"
          noValidate
          onSubmit={e => e.preventDefault()}
        >
          <div className="form-group">
            <label htmlFor="companyName">Organization Name</label>
            <div className="input-group">
              <input
                type="text"
                className={classnames('form-control', {
                  'is-invalid': profileValidation.errors.companyName,
                })}
                name="companyName"
                id="companyName"
                value={user.companyName || ''}
                onChange={this.onFieldChange('companyName')}
                onBlur={() => this.props.validateProfileField('companyName')}
              />
            </div>
            {profileValidation.errors.companyName && (
              <div className="invalid-feedback">{profileValidation.errors.companyName}</div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="organizationWebsite">Organization Website</label>
            <div className="input-group">
              <input
                type="text"
                className={classnames('form-control', {
                  'is-invalid': profileValidation.errors.organizationWebsite,
                })}
                name="organizationWebsite"
                id="organizationWebsite"
                value={user.organizationWebsite || ''}
                onChange={this.onFieldChange('organizationWebsite')}
                onBlur={() => this.props.validateProfileField('organizationWebsite')}
              />
            </div>
            {profileValidation.errors.organizationWebsite && (
              <div className="invalid-feedback">{profileValidation.errors.organizationWebsite}</div>
            )}
          </div>

          <button
            type="button"
            onClick={this.onContinue}
            className={classnames('btn plain-button gotham-bold-font continue', {
              disabled: !profileValidation.valid,
            })}
          >
            CONTINUE
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authenticated, currentUser } = state.session;
  const organizationRequired = requireOrganizationData(currentUser, authenticated);

  if (authenticated && currentUser && !organizationRequired) {
    ownProps.history.push('/v2/create-event/type');
  }

  return {
    user: state.registration.user,
    profileValidation: state.registration.postEventProfileValidation,
    currentUser: state.session.currentUser,
    userErrors: state.user.errors,
    userUpdated: state.user.updated,
    flash: state.flash,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateField: (field, value) => dispatch(registrationFieldUpdate(field, value)),
    validateProfileField: field => dispatch(postEventProfileFieldValidate(field)),
    changeProfileField: (name, value) => dispatch(changeProfileField({ name, value })),
    updateUser: user => dispatch(update(user)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Organization));
